export const ActionTypes = {
    MEMBER_ADDED: 'MEMBER_ADDED',
    MEMBER_REMOVED: 'MEMBER_REMOVED',
    ROLE_CHANGED: 'ROLE_CHANGED',
    ROLE_UPDATED: 'ROLE_UPDATED',
    WORKSPACE_CREATED: 'WORKSPACE_CREATED',
    WORKSPACE_UPDATED: 'WORKSPACE_UPDATED',
    WORKSPACE_DELETED: 'WORKSPACE_DELETED',
    BOARD_CREATED: 'BOARD_CREATED',
    BOARD_UPDATED: 'BOARD_UPDATED',
    BOARD_DELETED: 'BOARD_DELETED',
    ACTIONLIST_CREATED: 'ACTIONLIST_CREATED',
    ACTIONLIST_UPDATED: 'ACTIONLIST_UPDATED',
    ACTIONLIST_DELETED: 'ACTIONLIST_DELETED',
    CARD_CREATED: 'CARD_CREATED',
    CARD_UPDATED: 'CARD_UPDATED',
    CARD_DELETED: 'CARD_DELETED',
    COMMENT_ADDED: 'COMMENT_ADDED',
    COMMENT_DELETED: 'COMMENT_DELETED',
    COMMENT_UPDATED: 'COMMENT_UPDATED',
    COMMENT_REACTION_TOGGLED: 'COMMENT_REACTION_TOGGLED',
    REPLY_ADDED: 'REPLY_ADDED',
    REPLY_UPDATED: 'REPLY_UPDATED',
    REPLY_DELETED: 'REPLY_DELETED',
    REPLY_REACTION_TOGGLED: 'REPLY_REACTION_TOGGLED',
    CHECKLIST_ADDED: 'CHECKLIST_ADDED',
    CHECKLIST_DELETED: 'CHECKLIST_DELETED',
    CHECKLIST_UPDATED: 'CHECKLIST_UPDATED',
    CHECKLIST_ITEM_ADDED: 'CHECKLIST_ITEM_ADDED',
    CHECKLIST_ITEM_DELETED: 'CHECKLIST_ITEM_DELETED',
    CHECKLIST_ITEM_UPDATED: 'CHECKLIST_ITEM_UPDATED',
    CHECKLIST_ITEM_REORDERED: 'CHECKLIST_ITEM_REORDERED',
    ATTACHMENT_ADDED: 'ATTACHMENT_ADDED',
    ATTACHMENT_DELETED: 'ATTACHMENT_DELETED',
    ATTACHMENT_UPDATED: 'ATTACHMENT_UPDATED',
    DUEDATE_ADDED: 'DUEDATE_ADDED',
    DUEDATE_REMOVED: 'DUEDATE_REMOVED',
    DUEDATE_UPDATED: 'DUEDATE_UPDATED',
    PRIORITY_UPDATED: 'PRIORITY_UPDATED',
    LABEL_ADDED: 'LABEL_ADDED',
    LABEL_UPDATED: 'LABEL_UPDATED',
    LABEL_DELETED: 'LABEL_DELETED',
    CUSTOM_FIELD_DEFINED: 'CUSTOM_FIELD_DEFINED',
    CUSTOM_FIELD_UPDATED: 'CUSTOM_FIELD_UPDATED',
    CUSTOM_FIELD_DELETED: 'CUSTOM_FIELD_DELETED',
    CUSTOM_FIELD_REORDERED: 'CUSTOM_FIELD_REORDERED',
    CARD_CUSTOM_FIELD_UPDATED: 'CARD_CUSTOM_FIELD_UPDATED',
    CARD_ARCHIVED: 'CARD_ARCHIVED',
    CARD_UNARCHIVED: 'CARD_UNARCHIVED',
    CARD_MOVED: 'CARD_MOVED',
    LIST_MOVED: 'LIST_MOVED',

    // Page-related action types
    PAGE_CREATED: 'PAGE_CREATED',
    PAGE_UPDATED: 'PAGE_UPDATED',
    PAGE_DELETED: 'PAGE_DELETED',
    PAGE_ARCHIVED: 'PAGE_ARCHIVED',
    PAGE_MOVED: 'PAGE_MOVED',
    PAGE_REORDERED: 'PAGE_REORDERED',
    PAGE_CONTENT_UPDATED: 'PAGE_CONTENT_UPDATED',
    PAGE_MEMBER_ADDED: 'PAGE_MEMBER_ADDED',
    PAGE_MEMBER_UPDATED: 'PAGE_MEMBER_UPDATED',
    PAGE_MEMBER_REMOVED: 'PAGE_MEMBER_REMOVED',
    PAGE_FAVORITED: 'PAGE_FAVORITED',
    PAGE_VISIBILITY_CHANGED: 'PAGE_VISIBILITY_CHANGED',
    PAGE_PERMISSION_ADDED: 'PAGE_PERMISSION_ADDED',
    PAGE_PERMISSION_UPDATED: 'PAGE_PERMISSION_UPDATED',
    PAGE_PERMISSION_REMOVED: 'PAGE_PERMISSION_REMOVED',
    PAGE_PUBLIC_SHARED: 'PAGE_PUBLIC_SHARED',
    PAGE_PUBLIC_UNSHARED: 'PAGE_PUBLIC_UNSHARED',
    PAGE_RESTORED: 'PAGE_RESTORED',
    PAGE_BLOCK_CREATED: 'PAGE_BLOCK_CREATED',
    PAGE_BLOCK_UPDATED: 'PAGE_BLOCK_UPDATED',
    PAGE_BLOCK_DELETED: 'PAGE_BLOCK_DELETED',

    // Automation action types
    AUTOMATION_CREATED: 'AUTOMATION_CREATED',
    AUTOMATION_UPDATED: 'AUTOMATION_UPDATED',
    AUTOMATION_DELETED: 'AUTOMATION_DELETED',
    AUTOMATION_TOGGLED: 'AUTOMATION_TOGGLED',
    AUTOMATION_EXECUTED: 'AUTOMATION_EXECUTED',

    PAGE_COMMENT_ADDED: 'PAGE_COMMENT_ADDED',
    PAGE_COMMENT_UPDATED: 'PAGE_COMMENT_UPDATED',
    PAGE_COMMENT_DELETED: 'PAGE_COMMENT_DELETED',
    PAGE_COMMENT_REPLY_ADDED: 'PAGE_COMMENT_REPLY_ADDED',
    PAGE_COMMENT_RESOLVED: 'PAGE_COMMENT_RESOLVED',

};
